import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="fade-in" data-testid="page-about">
      <SEO title="About CreatorMic Pro" description="CreatorMic Pro is a creator-first audio company operated by CLSX LLC." path="/about" />

      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-8">
        <p className="eyebrow mb-4">About</p>
        <h1 className="text-h1 text-[#1D1D1F]">Built by creators, for creators.</h1>
        <p className="mt-6 text-lg text-[#86868B]">CreatorMic Pro was founded to close the gap between professional broadcast audio and the tools most creators actually own — a phone, a laptop, and a camera. Everything we ship is engineered to be plug-and-play, road-durable, and shockingly good-sounding out of the box.</p>
      </section>

      <section className="max-w-6xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-2 gap-10 items-center">
        <img src="https://images.unsplash.com/photo-1673767298248-b128f17f89af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="rounded-3xl w-full object-cover aspect-square" />
        <div>
          <h2 className="text-h2 text-[#1D1D1F]">Our mission</h2>
          <p className="mt-4 text-[#86868B]">Great stories deserve great sound. We build the wireless mics, USB-C interfaces, and lightning-fast adapters that let you focus on what matters — the story — while we handle the audio engineering.</p>
          <p className="mt-4 text-[#86868B]">We test every product in the same conditions our customers shoot in: busy streets, windy rooftops, tiny rideshares, packed conference halls. If it does not work there, it does not ship.</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 md:px-10 py-12 md:py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { h: "Independent", p: "Employee-owned, funded by our customers — not VCs. That is why our warranty is 2 years and our support answers in minutes, not weeks." },
            { h: "Creator-tested", p: "Every product passes real-world testing with 50+ working creators before it hits the store." },
            { h: "Sustainability first", p: "Recyclable packaging, repairable products, and a lifetime buy-back program on all wireless kits." },
          ].map((v) => (
            <div key={v.h} className="soft-card p-8">
              <h3 className="font-display text-xl font-bold text-[#1D1D1F]">{v.h}</h3>
              <p className="mt-3 text-[#86868B]">{v.p}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-10 py-16 text-center">
        <h2 className="text-h2 text-[#1D1D1F]">Ready to sound like a pro?</h2>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link to="/shop" className="btn-primary">Shop CreatorMic Pro</Link>
          <Link to="/contact" className="btn-secondary">Contact us</Link>
        </div>
      </section>
    </div>
  );
}
